const MINOR_UNITS = 100;

export const minorToMajor = (minor: number | null): string =>
	minor === null ? "" : (minor / MINOR_UNITS).toFixed(2);

export const majorToMinor = (major: string): number => {
	const value = Number(major);
	if (!Number.isFinite(value) || value < 0) return 0;
	return Math.round(value * MINOR_UNITS);
};
